import { render, staticRenderFns } from "./EditApp.vue?vue&type=template&id=590eee96&scoped=true"
import script from "./EditApp.vue?vue&type=script&lang=js"
export * from "./EditApp.vue?vue&type=script&lang=js"
import style0 from "./EditApp.vue?vue&type=style&index=0&id=590eee96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590eee96",
  null
  
)

export default component.exports